// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__blNCd","link":"Breadcrumbs_link__v9yGv","arrow":"Breadcrumbs_arrow__TkJpS"};